import * as Yup from "yup";
import i18next from "i18next";

export const ChangePasswordSchema = () => Yup.object({

    old_password: Yup.string().required(i18next.t('changePass.error_old_pass')),
    new_password: Yup.string().required(i18next.t('changePass.error_new_pass')),
    confirm_password: Yup.string()
        .oneOf([Yup.ref('new_password'), null], i18next.t('changePass.error_pass_match'))
        .required(i18next.t('changePass.error_confirm_pass')),

});